(() => {
  const CARD_LINKS = [
    { card: '.product-card-wrapper', link: '.card__heading a[href], a.card__heading[href]' },
    {
      card: '.hero-blokken__main, .hero-blokken__small-block, .hero-blokken__mobile-article',
      link: '.hero-blokken__button[href], .hero-blokken__block-link[href]',
    },
  ]
  const INTERACTIVE = 'a, button, input, select, textarea, label, [role="button"]'

  document.addEventListener('click', (e) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return
    if (e.target.closest(INTERACTIVE)) return

    for (const { card: cardSelector, link: linkSelector } of CARD_LINKS) {
      const card = e.target.closest(cardSelector)
      if (!card) continue

      const link = card.querySelector(linkSelector)
      if (link) window.location.href = link.href
      return
    }
  })
})()
